export default __webpack_public_path__ + "static/media/PT.b249980d.svg";